<po-modal
  #retryModal
  p-title="Reprocessar"
  p-size="md"
  [p-primary-action]="confirmAction"
  [p-secondary-action]="cancelAction"
  p-click-out="false">

  <!-- ══════════════════════════════════════════════════════
       PASSO 1 — Qual job reprocessar
       (igual VS Code: showQuickPick com review e/ou assistants)
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'job-select'" class="sr-options-grid">

    <po-widget
      class="sr-option-widget"
      *ngFor="let choice of choices"
      p-no-shadow="true"
      (p-click)="selectJob(choice)">
      <div class="sr-option-content">
        <div class="sr-option-icon" [ngSwitch]="choice.jobKey">
          <ng-container *ngSwitchCase="'review'"><span class="po-icon po-icon-search"></span></ng-container>
          <ng-container *ngSwitchCase="'assistant'"><span class="po-icon po-icon-chat"></span></ng-container>
        </div>
        <div class="sr-option-body">
          <div class="sr-option-title">{{ choice.label }}</div>
          <div class="sr-option-desc">{{ choice.description }}</div>
        </div>
      </div>
    </po-widget>

  </div>

  <!-- ══════════════════════════════════════════════════════
       PASSO 2 — Modo de reprocessamento
       (igual VS Code: showQuickPick all / missing)
  ═══════════════════════════════════════════════════════ -->
  <div *ngIf="currentStep === 'mode-select'">

    <!-- Resumo do job e modo selecionados -->
    <div class="sr-retry-summary" *ngIf="selectedChoice">
      <div class="sr-retry-summary-row">
        <span class="sr-retry-summary-label">Job:</span>
        {{ selectedChoice.label }}
        <span class="sr-retry-summary-meta">· {{ selectedChoice.description }}</span>
      </div>
      <div class="sr-retry-summary-row sr-retry-summary-mode" *ngIf="selectedMode">
        <span class="sr-retry-summary-label">Modo:</span>
        {{ selectedMode === 'all' ? 'Reprocessar tudo (all)' : 'Só o que falta (missing)' }}
      </div>
    </div>

    <div class="sr-options-grid sr-mt-12">

      <po-widget
        class="sr-option-widget"
        [class.sr-option-widget--selected]="selectedMode === 'all'"
        p-no-shadow="true"
        (p-click)="selectMode('all')">
        <div class="sr-option-content">
          <div class="sr-option-icon"><span class="po-icon po-icon-refresh"></span></div>
          <div class="sr-option-body">
            <div class="sr-option-title">all <span class="sr-option-badge">padrão</span></div>
            <div class="sr-option-desc" [ngSwitch]="selectedChoice?.jobKey">
              <ng-container *ngSwitchCase="'review'">Executa análise Sonar e gera novos prompts para todos os arquivos, descartando resultados anteriores.</ng-container>
              <ng-container *ngSwitchCase="'assistant'">Regenera a resposta de IA para todos os prompts existentes, descartando respostas anteriores.</ng-container>
            </div>
            <div class="sr-option-hint">Use quando o código foi alterado e você precisa de uma revisão completa atualizada.</div>
          </div>
          <span class="sr-option-check" *ngIf="selectedMode === 'all'"><span class="po-icon po-icon-ok"></span></span>
        </div>
      </po-widget>

      <po-widget
        class="sr-option-widget"
        [class.sr-option-widget--selected]="selectedMode === 'missing'"
        p-no-shadow="true"
        (p-click)="selectMode('missing')">
        <div class="sr-option-content">
          <div class="sr-option-icon"><span class="po-icon po-icon-copy"></span></div>
          <div class="sr-option-body">
            <div class="sr-option-title">missing</div>
            <div class="sr-option-desc" [ngSwitch]="selectedChoice?.jobKey">
              <ng-container *ngSwitchCase="'review'">Pula arquivos que já possuem análise Sonar e prompt gerado, reprocessando apenas o que falta.</ng-container>
              <ng-container *ngSwitchCase="'assistant'">Pula prompts que já possuem resposta válida, reprocessando apenas o que falta.</ng-container>
            </div>
            <div class="sr-option-hint">Use para retomar uma execução parcialmente concluída sem refazer o trabalho já feito.</div>
          </div>
          <span class="sr-option-check" *ngIf="selectedMode === 'missing'"><span class="po-icon po-icon-ok"></span></span>
        </div>
      </po-widget>

    </div>
  </div>

</po-modal>
